<div class="navigation-tabs">
  <div class="tab-container">
    <button 
      class="tab-button" 
      [class.active]="activeTab === 'available-cabs'"
      (click)="onTabClick('available-cabs')">
      <mat-icon class="tab-icon">directions_car</mat-icon>
      <span class="tab-text">Available Cabs</span>
    </button>
    
    <button 
      class="tab-button" 
      [class.active]="activeTab === 'my-bookings'"
      (click)="onTabClick('my-bookings')">
      <mat-icon class="tab-icon">event_available</mat-icon>
      <span class="tab-text">My Bookings</span>
    </button>
  </div>
</div> 